import { useQuery } from '@tanstack/react-query';

import { FetchPartnersResponse, partnersService } from '@aslanpay/portal-common-lib';

const useFetchPartners = () => {
  return useQuery<FetchPartnersResponse, Error>(['fetchPartners'], () =>
    partnersService.fetchPartners({ page: 0, size: 999999, status: ['ACTIVE'] })
  );
};

export default useFetchPartners;
